import { gql } from "apollo-boost";

export const ACKNOWLEDGE_UPDATE_SAVED_OPEN_HOUSE = gql`
  mutation acknowledge_update_saved_open_house($saved_open_house_id: ID!) {
    acknowledge_update_saved_open_house(
      input: { saved_open_house_id: $saved_open_house_id }
    ) {
      ... on AcknowledgeUpdateSavedOpenHouseResult {
        successful
      }
      ... on AcknowledgeUpdateSavedOpenHouseErrors {
        errors {
          message
          type
        }
      }
    }
  }
`;
